import React, {useState} from "react";
import {Box, Tab, Tabs} from "@mui/material";
import styled from "styled-components";
import UserData from "../../components/user-settings-tabs/UserData";
import PasswordSecurity from "../../components/user-settings-tabs/PasswordSecurity";
import MainCard from "../../components/common/MainCard";
import {Header, UserSettingsWrapper} from "./UserSettings.styled";
import {useTranslation} from 'react-i18next';

const CenteredHeader = styled(Header)`
    justify-content: center;

    h2 {
        margin: 0;
    }
`;

const UserSettings: React.FC = () => {
    const {t} = useTranslation();
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <UserSettingsWrapper role="region" aria-labelledby="user-settings-title">
            <MainCard width="100%" height="auto">
                <CenteredHeader>
                    <h2 id="user-settings-title">{t('userSettings.title')}</h2>
                </CenteredHeader>
                <Box sx={{borderBottom: 'none !important'}}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        aria-label={t('userSettings.tabs.ariaLabel') as string}
                    >
                        <Tab id="user-data-tab" aria-controls="user-data-panel" label={t('userSettings.userData')} sx={{textTransform: 'none'}}/>
                        <Tab id="password-security-tab" aria-controls="password-security-panel" label={t('userSettings.passwordSecurity')} sx={{textTransform: 'none'}}/>
                    </Tabs>
                </Box>

                {activeTab === 0 && (
                    <Box role="tabpanel" id="user-data-panel" aria-labelledby="user-data-tab" aria-label={t('userSettings.panel.userData.ariaLabel') as string}>
                        <UserData/>
                    </Box>
                )}
                {activeTab === 1 && (
                    <Box role="tabpanel" id="password-security-panel" aria-labelledby="password-security-tab" aria-label={t('userSettings.panel.passwordSecurity.ariaLabel') as string}>
                        <PasswordSecurity/>
                    </Box>
                )}
            </MainCard>
        </UserSettingsWrapper>
    );
};

export default UserSettings;
